import request from './index.js'

//页面数据
export function newsList(query) {
    return request({
        url: '/api/list/newsList?'+ query,
        method: 'get',
        query
    })
}

export function newsInfo(id) {
    return request({
        url: '/api/list/'+ id,
        method: 'get',
    })
}

export function bannerList(type) {
    return request({
        url: '/api/banner/bList?type=' + type,
        method: 'get',
    })
}


export function GetVideo() {
    return request({
        url: '/api/list/vedio',
        method: 'get',
    })
}



export function getPark() {
    return request({
        url: '/api/list/parkList?pageNum=1&pageSize=999',
        method: 'get',
    })
}



export function getPosi(val) {
    return request({
        url: '/api/position/getAreaListByPid' + val,
        method: 'get',
    })
}
// 新增企业选址信息
export function saveSite(data) {
    return request({
        url: '/api/list/saveSite',
        method: 'post',
        data
    })
}
// 新增园区落户意向
export function saveSettle(data) {
    return request({
        url: '/api/list/saveSettle',
        method: 'post',
        data
    })
}

export function getIndustry(data) {
    return request({
        url: '/api/position/IndustryCategoryParent',
        method: 'get',
        data
    })
}


export function getIndustryPid(id) {
    return request({
        url: '/api/position/IndustryCategoryChild?pid=' + id,
        method: 'get',
    })
}


// WEBPACK FOOTER //
// ./src/api/home.js